/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stripe_Unavailable_BodyInputs */

const en_stripe_unavailable_body = /** @type {(inputs: Stripe_Unavailable_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We couldn't load Stripe, our payment provider. An ad blocker or privacy extension is usually the cause — disable it for this page and reload.`)
};

const es_stripe_unavailable_body = /** @type {(inputs: Stripe_Unavailable_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No pudimos cargar Stripe, nuestro proveedor de pagos. Normalmente la causa es un bloqueador de anuncios o una extensión de privacidad: desactívalo para esta página y vuelve a cargarla.`)
};

/**
* | output |
* | --- |
* | "We couldn't load Stripe, our payment provider. An ad blocker or privacy extension is usually the cause — disable it for this page and reload." |
*
* @param {Stripe_Unavailable_BodyInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const stripe_unavailable_body = /** @type {((inputs?: Stripe_Unavailable_BodyInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stripe_Unavailable_BodyInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_stripe_unavailable_body(inputs)
	return en_stripe_unavailable_body(inputs)
});